import { useState, useEffect, Fragment } from "react";
import { IMAGE_BUCKET_URL, GET_QR_CODE, QR_DEPOSIT  } from "../../DataStore/ApiConstant";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import _ from "lodash";
import axios from "axios";
import { CRYPTOURL, CRYPTO_MERCHANT, DEOSITBONUSURL,} from "../../DataStore/ApiConstant";
import BonusOffer from "../TransactionCommon/BonusOffer";
import { useAtom } from "jotai";
import { bonusStore } from "../../DataStore/atom";
import { getFormData, calculateBonus, calculateTurnover } from "../../utils";
import { useDepositBonus } from "../../services/cashier";
import { useCurrencyRates } from "../../services/cashier";
import { useInrToUsd } from "../../services/config";
import {NumericFormat} from "react-number-format";
import QRupiComponent from "../../Components/Modal/GeneralModal/QRupiComponent";
import { Image } from "react-bootstrap";

import { useParams } from 'react-router-dom';
const currencyRules = [
  { currency: "USD", min: 50, max: 5000 }
];

const getValidatorSchema = () => {
  const { min, max } = currencyRules.find((rule) => rule.currency === "USD");
  return yup.object().shape({
    amount: yup
      .number()
      // .required("Please provide amount.")
      .min(min, `Must be greater than or equal to ${min}`)
      .max(max, `Must be less than or equal to ${max}`)
      .typeError("Amount must be a number"),
  });
};


const Crypto = () => {
  const [BonusStore, setBonusStore] = useAtom(bonusStore);
  const [depositBonus, setDepositBonus] = useState(true);
  const [reBonus, setReBonus] = useState(0);
  const [reTurn, setReTurn] = useState(0);
  const [usd, setUsd] = useState(0);
  const [load, setLoad] = useState(false);

  const [lkrAmount, setLkrAmount] = useState(0);
  const [inrAmount, setInrAmount] = useState(0);

  const [selectedOption, setSelectedOption] = useState(1);


  const[currenyData , setCurrencyData] = useState([]);

  const { type } = useParams();
  const [showSuccessMessage, setShowSuccessMessage] = useState(null);
  const [amount, setAmount] = useState(0);
  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const [paymentErr, setPaymentErr] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  const schema = getValidatorSchema();
  const { handleSubmit, formState: { errors }, register, reset } = useForm({ resolver: yupResolver(schema) });
  
  // const bonus = useWithdrawBonus();
  const currency = useCurrencyRates();
  const bonus = useDepositBonus();
  const InrToUsd = useInrToUsd();
  // console.log(currency?.data?.data[0]?.rate);
  // console.log(currency?.data?.data[36]?.rate);
  
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      // style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  const handleBackClick = () => {
    window.location.href = '/cashier';
  };

  const submitHandler = async () => {
    if(amount === "" || amount <= 0){
      setPaymentErr("Please enter a valid amount")
      const timer = setTimeout(() => {
        setPaymentErr(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
    // setLoad(true)
    // let bonusAmt = 0;
    // depositBonus == null ? (bonusAmt = 0) : (bonusAmt = 1);
    // const formData = new FormData();
    // formData.append('amount', usd);
    // formData.append('url', "/cashier");
    // formData.append('bonus', bonusAmt);
    // axios
    //   .post(CRYPTOURL, formData)
    //   .then((resp) => {
    //     // console.log(resp?.data?.data.token);
    //     let ResState = resp?.data?.state
    //     let token = resp?.data?.data.token
    //     if(ResState == true){
    //       let url = CRYPTO_MERCHANT + token;
    //       window.location.href = url;
    //       // setSuccessMsg(resp.data.message || 'Please Wait');
    //       setLoad(false);
    //     }
    //     setErrmsg('');
    //   })
    //   .catch((err) => {
    //     setPaymentErr(err);
    //     setLoad(false);
    //   })
    setLoad(true)
    let bonusAmt = 0;
    depositBonus == null ? (bonusAmt = 0) : (bonusAmt = 1);
    const formData = {"bonus": bonusAmt, 'fiatAmount': String(amount),'provider': "crypto", "currencyType": String(selectedCurrency) }

    axios
      .post(CRYPTOURL, formData)
      .then((resp) => {
        // if(resp?.data?.success){
        //   const redirectUrl = resp.data.url;
        //   window.location.href = redirectUrl;
        //   setLoad(false);
        // }
        // setErrmsg('');
        if (resp?.data?.success) {
          if(resp?.data?.type == "qr"){
            setQrCodeUrl(resp?.data?.value);
            setIsModalOpen(true)
            setLoad(false);
            return
          }
          else{
            const redirectUrl = resp?.data?.value;
            window.location.href = redirectUrl;
            setLoad(false);
            return
          }
        } else {
          setErrmsg(resp?.data?.error || 'An unknown error has occured')
          setLoad(false);
        }
      })
      .catch((err) => {
        setPaymentErr(err);
        setLoad(false);
      })
  };


              const [selectedCurrency, setSelectedCurrency] = useState(null);

              // Handler to set the icon URL when an image is clicked
              const handleCurrencyClick = (type) => {
                setSelectedCurrency(type);
              };

              const fetchCurrencyData = async () => {

                // Fetch available crypto currencies
              fetch('/api/paymentgws/crypto_currencies')
              .then(response => response.json())
              .then(data => {
                  console.log("data",data)
                  setCurrencyData(data)

              });
              }

              useEffect(() => {
                fetchCurrencyData();
              }, []);
  





  const handleFocus = (event) => {
    event.target.select();
  };
  
  const calculateBonuses = (reAmount) => {

    setAmount(reAmount);
    
    if (bonus.data) {
      let bonusRet = calculateBonus(
        reAmount,
        bonus?.data?.maxbonus || 0,
        bonus?.data?.bonusprecent || 0
      );
      setReBonus(bonusRet);
      let turnRet = calculateTurnover(
        reAmount,
        bonus?.data?.maxbonus || 0,
        bonus?.data?.turnover || 0,
        bonus?.data?.bonusprecent || 0
      );
      setReTurn(turnRet)
      
    }
    // if(!InrToUsd.isLoading && InrToUsd?.data){
      
    // let lkrToUsdAmount = parseFloat(reAmount) * parseFloat(InrToUsd?.data?.[0]?.value || 0.012)
    // let lkrToUsdAmount = (parseFloat( !currency.isLoading && currency?.data?.data?.[0]?.rate) / parseFloat(!currency.isLoading && currency?.data?.data?.[36]?.rate) * parseFloat(reAmount))
    let usdCurrency = !currency.isLoading && currency?.data?.data.find(item => item.cur === "USDT")
    let inrCurrency = !currency.isLoading && currency?.data?.data.find(item => item.cur === "INR")
    
    let calculatedInr = (parseFloat(usdCurrency.rate) / (parseFloat( inrCurrency.rate)) * parseFloat(reAmount))
    let calculatedLkr = (parseFloat(reAmount) * parseFloat(usdCurrency.rate))
    setInrAmount(calculatedInr.toFixed(0))
    setLkrAmount(calculatedLkr.toFixed(0))

      const { min, max } = currencyRules.find((rule) => rule.currency === "USD");
      if (reAmount !== "" && (reAmount < min || reAmount > max)) {
        setPaymentErr(`USDT amount must be between min and max limit: ${min} - ${new Intl.NumberFormat('en-LK', { style: 'currency', currency: 'LKR', maximumFractionDigits: 0 }).format(max)}`);
        setLoad(true)
      } else {
        setPaymentErr(false);
        setLoad(false)
      }
      // lkrToUsdAmount = parseFloat(lkrToUsdAmount.toFixed(3));
      // setUsd(lkrToUsdAmount || 0)
    // }
  };
  const bonusOfferSwitch = async (status) => {
    setSelectedOption((prevOption) => (prevOption === status ? "" : status));

    setBonusStore(status);
    if (status) {
      axios
        .get(DEOSITBONUSURL)
        .then((resp) => {
          setDepositBonus(resp);
        })
        .catch((err) => {
          
        });
    } else {
      setDepositBonus(null);
    }
  };

  useEffect(() => {
    setSelectedCurrency(null);
    reset();
  }, [reset]);

  useEffect(() => {
    if (type == "success") {
      const cryptoTab = document.getElementById('v-pills-crypto-tab');
      if (cryptoTab) cryptoTab.click()
      setShowSuccessMessage("Your transaction was successful!");
  
      const timer = setTimeout(() => {
        setShowSuccessMessage(null);
      }, 5000);
  
      return () => clearTimeout(timer);
    }
    if(type == "cancel"){
      const cryptoTab = document.getElementById('v-pills-crypto-tab');
      if (cryptoTab) cryptoTab.click()
      setShowSuccessMessage("Your transaction failed!");
  
      const timer = setTimeout(() => {
        setShowSuccessMessage(null);
      }, 5000);
  
      return () => clearTimeout(timer);
    }
  }, [type]);
  return (
    <Fragment>
    <div
      className="tab-pane fade "
      id="v-pills-crypto"
      role="tabpane5"
      aria-labelledby="v-pills-crypto-tab"
    >
      <div className="row d-flex justify-content-center visible">
                 <img
                      src={IMAGE_BUCKET_URL + "cryptoComingSoon.jpg"}
                      className="img-fluid"
                      alt=""
                    />

            </div>
      </div>
          
    {/* <div>
      <QRupiComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        qrCodeValue={qrCodeUrl}
      />
    </div> */}
    </Fragment>
    
  );
};

export default Crypto;
